module.exports = __webpack_public_path__ + "img/www_pack.01c9fb15.png";